import { request } from '../request';
import {
  IAsrReq,
  IAsrResp,
  IGetVoiceReq,
  IGetVoiceResp,
  IRestartConversationReq,
  IRevertConversationReq,
  IVerifyConversationAttachmentReq,
  IVerifyConversationAttachmentResp,
  IVerifyConversationExtractReq,
  IVerifyConversationExtractResp,
  IVoiceChatReq,
  IVoiceChatResp,
} from '../types';

// 获取语音
export const postGetVoice = async (data: IGetVoiceReq): Promise<IGetVoiceResp> => {
  const url = '/weaver/api/v1/conversation/msg/get_voice';
  return await request.post(url, data);
};

// 对话重启
export const postRestartConversation = async (data: IRestartConversationReq): Promise<void> => {
  const url = '/weaver/api/v1/conversation/restart_conversation';
  return await request.post(url, data);
};

// 图片校验
export const postVerifyAttachment = async (
  data: IVerifyConversationAttachmentReq
): Promise<IVerifyConversationAttachmentResp> => {
  const url = '/weaver/api/v1/conversation/verify_attachment';

  return await request.post(url, data);
};

// 内容提取
export const postExtractAttachment = async (
  data: IVerifyConversationExtractReq
): Promise<IVerifyConversationExtractResp> => {
  const url = '/weaver/api/v1/conversation/extract_attachment';

  return await request.post(url, data);
};

// ASR
export const postAsr = async (data: IAsrReq): Promise<IAsrResp> => {
  const url = '/weaver/api/v1/conversation/asr';

  return await request.post(url, data);
};

// text01 流式对话
export const postVoiceChat = async (data: IVoiceChatReq): Promise<IVoiceChatResp> => {
  const url = '/weaver/api/v1/conversation/stream/voice_chat';

  return await request.post(url, data);
};

export const postGetRevertConversation = async (data: IRevertConversationReq): Promise<void> => {
  const url = '/weaver/api/v1/conversation/revert_conversation';

  return await request.post(url, data);
};
